import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import SectionTimestampNotice from "./SectionTimestampNotice";

function TechnicianOnlyReviewSection({
  jobOrder = {},
  isTechnician = false,
  editableSchedule = false,
  onStartTimeChange,
  onEndTimeChange,
}) {
  const accomplishedTechnicians =
    jobOrder.accomplished_by_technician ||
    jobOrder.technicians ||
    [];

  const technicianNames = accomplishedTechnicians.map((name) =>
    typeof name === "string"
      ? name
      : `${name.firstname || ""} ${name.lastname || ""}`.trim()
  );

  const technicianOptions = (jobOrder.technicians || []).map((tech) => {
    if (typeof tech === "string") {
      return tech;
    }
    return `${tech.firstname || ""} ${tech.lastname || ""}`.trim();
  });

  return (
    <>
      <Grid item xs={12}>
        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent sx={{ p: 2 }}>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
              Service Accomplished by:
            </Typography>

            <Grid container spacing={2}>
              {technicianNames.map((techName, i) => (
                <Grid key={i} item xs={12}>
                  <TextField
                    label={`Technician ${i + 1}`}
                    variant="outlined"
                    fullWidth
                    size="small"
                    value={techName}
                    disabled
                  />
                </Grid>
              ))}

              <Grid item xs={12}>
                {jobOrder.accomplishedSignature && (
                  <Box
                    component="img"
                    src={jobOrder.accomplishedSignature}
                    alt="Accomplished Signature"
                    sx={{
                      width: "100%",
                      maxWidth: 400,
                      height: 120,
                      objectFit: "contain",
                      border: "1px solid rgba(0,0,0,0.3)",
                      mb: 2,
                    }}
                  />
                )}
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth margin="normal">
                  <InputLabel id="technician-signatory-label">
                    Technician Signatory
                  </InputLabel>
                  <Select
                    labelId="technician-signatory-label"
                    value={jobOrder.technician_signatory || ""}
                    label="Technician Signatory"
                    disabled
                  >
                    {technicianOptions.map((techName, idx) => (
                      <MenuItem key={`${techName}-${idx}`} value={techName}>
                        {techName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <SectionTimestampNotice
                  label="Technician Signature Uploaded At"
                  value={jobOrder?.technician_signature_uploaded_at}
                  colorSet="info"
                  hidden={isTechnician}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid
        item
        xs={12}
        md={12}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <Card
          variant="outlined"
          sx={{
            marginBottom: { xs: "5px", md: "5px", lg: "10px", xl: "20px" },
            flex: 1,
          }}
        >
          <CardHeader
            title={
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  fontSize: "1rem",
                }}
              >
                Schedule
              </Typography>
            }
          />
          <CardContent sx={{ flex: 1 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <TextField
                  label="Start Date"
                  name="job_date"
                  type="date"
                  value={jobOrder?.job_date || ""}
                  fullWidth
                  disabled
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="Start Time"
                  name="start_time"
                  type="time"
                  value={jobOrder?.start_time || ""}
                  fullWidth
                  disabled={!editableSchedule}
                  onChange={(e) => onStartTimeChange?.(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="End Time"
                  name="end_time"
                  type="time"
                  value={jobOrder?.end_time || ""}
                  fullWidth
                  disabled={!editableSchedule}
                  onChange={(e) => onEndTimeChange?.(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
}

export default TechnicianOnlyReviewSection;